var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_c('strong',[_vm._v("Access Denied: You do not have access to this tenant. Are you using the correct URL? ")])])])
}]

export { render, staticRenderFns }